import NeutralButton from '@components/buttons/NeutralButton';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addTransition, mq } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledAccountTooltip = styled.div`
	position: relative;
`;

export const StyledAccountTooltipContainer = styled.div<{ isVisible: boolean }>`
	position: absolute;
	top: 120%;
	left: calc(50% - 208px);
	z-index: 420;
	text-align: center;
	background-color: ${(p) => p.theme.colors.black};
	border: 1px solid ${(p) => p.theme.colors.gold};
	border-radius: 5px;
	width: 256px;
	padding: ${(p) => p.theme.spacing.s};
	filter: drop-shadow(0px 0px 25px ${(p) => p.theme.colors.black + '50'});

	${addTransition()}

	${mq(
		EMediaQuery.md,
		`
		top: 110%;
		left: calc(50% - 128px);
	`
	)}

	${(p) =>
		p.isVisible
			? `
		opacity: 1;
		pointer-events: all;
		transform: translateY(0);
	`
			: `
		opacity: 0;
		pointer-events: none;
		transform: translateY(5px);
	`}

	&::after {
		content: ' ';
	}
`;

export const StyledArrow = styled.div`
	position: absolute;
	top: -6px;
	right: calc(43px);

	${mq(
		EMediaQuery.md,
		`
		right: calc(50% - 5px);
	`
	)}

	& > span {
		display: block;

		width: 10px;
		height: 10px;

		transform: rotate(-135deg);

		background-color: ${(p) => p.theme.colors.black};

		border: 1px solid ${(p) => p.theme.colors.gold};

		border-top: none;
		border-left: none;
	}
`;

export const StyledRoundedImage = styled.img`
	border-radius: 50%;
	width: 62px;
	height: 62px;
	margin-right: 10px;

	border: 1px solid ${(p) => p.theme.colors.gold};
`;

export const NeutralButtonEx = styled(NeutralButton)`
	margin-bottom: ${(p) => p.theme.spacing['3xs']};

	:last-of-type {
		margin-bottom: 0;
	}
`;
